import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { mixslitEntry } = stateEnum

const initialState = {
  detailParams: {},
  isNewEntry: false,
}


const mixSlitEntrySlice = createSlice({
  name: mixslitEntry,
  initialState,
  reducers: {

    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    resetDetailParams: (state) => {
      state.detailParams = {}
      state.isNewEntry = true

    },
  },

})

export const { setDetailParams, resetDetailParams, setNewEntryMode, setMemoParams } = mixSlitEntrySlice.actions
export default mixSlitEntrySlice.reducer
